export interface ITileMenuItemProps {
  id: string; //unique
  title: string;
  icon?: string;
  color?: string;
  orderIndex?: number;
  raised?: boolean;
  size?: 'sm' | 'md' | 'lg';
  showIfUnauthenticated?: boolean;
  onPress?: any;
  spacing?: number;
}

export interface ITileMenuProps {
  numberOfColumns?: number;
  components: ITileMenuItemProps[];
}
